import { FAQS } from "@/config";
import { SectionHeading } from "@/components/Section";
import { Reveal } from "@/components/Reveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function FaqSection({ limit, showHeading = true }) {
  const list = limit ? FAQS.slice(0, limit) : FAQS;
  return (
    <section data-testid="faq" className="py-24 md:py-32 bg-cream">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 grid lg:grid-cols-[0.8fr_1.2fr] gap-12">
        {showHeading && (
          <SectionHeading
            chapter="12 / FAQ"
            overline="Common Questions"
            title={<>Everything you need to know before opening an account</>}
            lead="Answers are editable so our team can finalize exact policies. Still unsure? Our wholesale team is happy to help."
          />
        )}
        <Reveal className={showHeading ? "" : "lg:col-span-2"}>
          <Accordion type="single" collapsible className="w-full">
            {list.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} data-testid={`faq-item-${i}`} className="border-forest/15">
                <AccordionTrigger className="text-left font-display text-lg text-forest hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-forest/70 text-[15px] leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
